import type { FC, ReactNode } from 'react'
import type { Faq } from '@/types'

import { MessageSquareText } from 'lucide-react'
import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { ButtonLink } from '@/components/generals/button'
import { Reveal } from '@/components/motion/reveal'
import { FaqAccordion } from '@/components/widgets/faq-accordion'
import { faqs } from '@/constants/trust'
import { siteConfig } from '@/constants/site'

interface FaqSectionProps {
    items?: Faq[]
    className?: string
}

export const FaqSection: FC<FaqSectionProps> = ({ items = faqs, className }): ReactNode => {
    return (
        <section id='faq' className={className ?? 'py-24 md:py-32'}>
            <Container className='grid gap-12 lg:grid-cols-12 lg:gap-10'>
                <div className='lg:col-span-5'>
                    <div className='lg:sticky lg:top-32'>
                        <SectionHeading
                            layout='stack'
                            eyebrow="Common questions"
                            title="Good to know first."
                            description={<>Something we didn't cover? Send a text to <span className='font-mono text-ink'>{siteConfig.phone}</span> and a technician will answer it.</>}
                            action={(
                                <ButtonLink href={siteConfig.smsHref} variant='outline' icon={MessageSquareText}>
                                    Ask a technician by text
                                </ButtonLink>
                            )}
                        />
                    </div>
                </div>

                <Reveal className='lg:col-span-7'>
                    <FaqAccordion items={items} />
                </Reveal>
            </Container>
        </section>
    )
}
